import React, { Component } from 'react'
import Footer from './MarketingFooter'
import Header from './MarketingHeader'
import styled from 'styled-components'

import cssVar from '../../styles/variables'
import { MaxContentWidthWrapper } from '../marketing/MarketingStyles';
import RequestInformationModal from '../marketing/RequestInformationModal';
import CheckAvailibilityModal from '../marketing/CheckAvailibilityModal';
import CookieModal from '../marketing/CookieModal';

class Layout extends Component {

  render() {
    return (
      <div>
        <Header />
        <ContentWrapper>
          { this.props.children }
        </ContentWrapper>
        <Footer />

        { /* MODALS */ }
        <RequestInformationModal />
        <CheckAvailibilityModal />
        <CookieModal />
      </div>
    )
  }
}

export default Layout

const ContentWrapper = styled(MaxContentWidthWrapper) `
  background: white;
  width: 100vw;
  max-width: 100vw;
  overflow-x: hidden;
  min-height: calc( 100vh - ${ cssVar.headerHeight }px );
  margin-top: ${ cssVar.headerHeight }px;
  color: ${ cssVar.colors.blue };
`



// WEBPACK FOOTER //
// /src/components/layout/MarketingLayout.js